import "./style.css";
import { h as s, T as c, i, j as l } from "./index-buEOnV4i.js";
const p = (e) => `v-on:${e.toLowerCase()}`, u = (e, t) => (r) => s({
  code: e,
  context: t.context,
  localState: t.localState,
  rootState: t.rootState,
  rootSetState: t.rootSetState,
  event: r,
  isExpression: !1,
  enableCache: !0
});
function m(e) {
  const t = {}, r = e.block.actions ?? {};
  for (const a in r) {
    if (!r.hasOwnProperty(a))
      continue;
    const n = r[a];
    let o = p(a);
    if (e.stripPrefix)
      switch (c) {
        case "vue":
          o = o.replace("v-on:", "");
          break;
        case "svelte":
          o = o.replace("on:", "");
          break;
      }
    t[o] = u(n, e);
  }
  return t;
}
function f({
  properties: e
}) {
  return e;
}
const v = (e) => ({
  href: e.href
});
function g({
  block: e,
  context: t
}) {
  var a;
  const r = {
    ...v(e),
    ...e.properties,
    "builder-id": e.id,
    style: i({
      block: e,
      context: t
    }),
    [l()]: [e.id, "builder-block", e.class, (a = e.properties) == null ? void 0 : a.class].filter(Boolean).join(" ")
  };
  return f({
    properties: r,
    context: t,
    block: e
  });
}
export {
  g as a,
  m as g
};
